// Compile our scss
// This 'includes' the SCSS index file which webpack then reads and
// compiles into the necessary css files
require("../scss/index.scss");

//require main.js

require("./event-registration-form-app/main.jsx");

// Inject our components
require("./components/navigation.js");
require("./components/megamenus.js");
require("./components/togglable-content.js");
require("./components/responsive-images.js");
require("./components/sliders.js");
require("./components/image-galleries.js");
require("./components/bookmark-button.js");
require("./components/notice-banner");
require("./components/club-filter");
require("./components/events-section");
require("./components/member-market-filters");
